import {z} from "zod";
import {conditionSchema} from "../../segments/segment-form/schema";

const conditionGroupSchema = z.object({
  name: z.string(),
  match_mode: z.enum(["all", "any"]),
  conditions: z.array(conditionSchema),
});

export const baseFlowFormSchema = z.object({
  name: z.string().trim().min(1, "Enter a test name"),
  feature_flag: z.string().min(1, "Select a feature flag"),
  group_match_mode: z.enum(["all", "any"]),
  groups: z.array(conditionGroupSchema),
});

export const NO_VARIANTS_MESSAGE = "The feature flag has no variants";

export type BaseFlowFormValues = z.infer<typeof baseFlowFormSchema>;
export type ConditionGroupFormValues = BaseFlowFormValues["groups"][number];
export type ConditionFormValues = ConditionGroupFormValues["conditions"][number];

export type BaseVariantFormValues = {name: string; label: string; weight: number};
